"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationLeitungFormatter = void 0;
const ConfigurationLeitungFormValidator_1 = require("./ConfigurationLeitungFormValidator");
class ConfigurationLeitungFormatter {
    static anzahl(options) {
        return ConfigurationLeitungFormValidator_1.ConfigurationLeitungFormValidator.anzahl(options);
    }
}
exports.ConfigurationLeitungFormatter = ConfigurationLeitungFormatter;
//# sourceMappingURL=ConfigurationLeitungFormatter.js.map